<template>
  <form action="" @submit.prevent="handleFormSubmit">
    <div>
      <div class="mt-1 flex rounded-md shadow">
        <div class="relative flex-grow focus-within:z-10">
          <div
            class="absolute inset-y-0 left-0 pl-3 flex items-center cursor-pointer"
            v-click-outside="closeevent"
            @click="
              () => {
                showEmojiWindow = !showEmojiWindow;
              }
            "
          >
            <svg
              class="h-6 w-6 stroke-current text-darkblue"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </div>
          <!--          <emoji-window-->
          <!--            :show-emoji-window="showEmojiWindow"-->
          <!--            v-on:add-emoji="addEmoji"-->
          <!--            v-on:close-window="handleWindowClosed"-->
          <!--          ></emoji-window>-->
          <picker
            @select="addEmoji"
            title="Pick your emoji"
            emoji="point_up"
            :native="true"
            v-show="showEmojiWindow"
          />
          <textarea
            ref="inputRef"
            v-model="input"
            class="form-input block w-full rounded-none rounded-l-md pl-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            placeholder="Say more ..."
            v-on:keydown.enter="handleFormSubmit"
            v-on:keyup.enter="handleEnterKeyUp"
          />
        </div>
        <button
          class="ml-px relative inline-flex font-open-sans items-center px-4 py-2 border border-darkBlue bg-vectric text-white leading-5 font-medium rounded-r-md
          focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
          :disabled="isDisabled"
        >
          <span class="ml-2">Send</span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { Picker } from "emoji-mart-vue";
import EmojiWindow from "./EmojiWindow";
import { ClickOutside } from "../utils/ClickOutside";

export default {
  name: "MessageInput",
  // eslint-disable-next-line vue/no-unused-components
  components: { EmojiWindow, Picker },
  data: function() {
    return {
      input: "",
      showEmojiWindow: false
    };
  },
  directives: {
    "click-outside": ClickOutside()
  },
  created: function() {
    this.$on("closeevent", this.closeevent);
  },
  computed: {
    isDisabled() {
      console.log(
        `'isDisabled' ${this.input === undefined ||
          this.input == null ||
          this.input.trim().length == 0}`
      );
      return (
        this.input === undefined ||
        this.input == null ||
        this.input.trim().length == 0
      );
    }
  },
  methods: {
    closeevent: function() {
      this.showEmojiWindow = false;
    },
    handleWindowClosed() {
      console.log("Picker Closed");
      this.showEmojiWindow = false;
    },
    //
    // handle the form submission
    //
    handleFormSubmit(event) {
      if (event.shiftKey) {
        return;
      }

      const str = this.input.trim();
      if (str.length == 0) {
        return;
      }

      this.$emit("message-sent", { body: this.input });
      this.input = "";
    },
    handleEnterKeyUp(event) {
      if (event.shiftKey) {
        return;
      }
      const str = this.input.trim();
      if (str.length == 0) {
        this.input = "";
      }
    },
    //
    // Add an emoji and reset the cursor
    //
    addEmoji(emoji) {
      const input = this.$refs.inputRef;
      const cursorPosition = input.selectionEnd;
      const start = this.input.substring(0, input.selectionStart);
      const end = this.input.substring(input.selectionStart);
      const text = start + emoji.native + end;
      console.log(text);
      // this.$emit('input', text)
      this.input = text;
      input.focus();
      this.$nextTick(() => {
        input.selectionEnd = cursorPosition + emoji.native.length;
      });
      this.showEmojiWindow = false;
    },
    focusInput() {
      this.$refs.inputRef.focus();
    }
  }
};
</script>

<style scoped>
.emoji-mart {
  position: absolute;
  top: -400px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
</style>
